var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_3615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7C15 8.54033 14.3685 10.4436 13.3301 11.9602C12.2834 13.4888 10.9149 14.5 9.5 14.5C8.08506 14.5 6.71659 13.4888 5.66992 11.9602C4.63152 10.4436 4 8.54033 4 7C4 3.96243 6.46243 1.5 9.5 1.5C12.5376 1.5 15 3.96243 15 7Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6318 14.5C14.4438 15.4001 15.4329 16 16.5001 16C19.2615 16 21.5001 11.9832 21.5001 9.14286C21.5001 6.30254 19.2615 4 16.5001 4C16.3313 4 16.1645 4.0086 16.0001 4.02539",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14C10.5 14.7364 10.0523 16 9.5 16C8.94772 16 8.5 14.7364 8.5 14",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.5C17.5 16.2364 17.0523 17.5 16.5 17.5C15.9477 17.5 15.5 16.2364 15.5 15.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 23C11.6667 23 13 22.7 13 21.5C13 20.3 11.6667 19.6667 11 19.5C10.5 19.3333 9.5 18.7 9.5 17.5C9.5 16.3 9.5 16.6667 9.5 16.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3571 22.5C17.7381 22.5 18.5 22.2692 18.5 21.3462C18.5 20.4231 17.7381 19.9359 17.3571 19.8077C17.0714 19.6795 16.5 19.1923 16.5 18.2692C16.5 17.3462 16.5 17.6282 16.5 17.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_3615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.633c8f5a.svg";
export { ForwardRef as ReactComponent };